import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import CloseIcon from '@/public/icons/close_black.svg';
import WorkingHoursChange from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/WorkingHoursChange';
import useWorkingHoursChangeProps from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/WorkingHoursChange/@hooks/useWorkingHoursChangeProps';
import { SubContentProps } from '../LanguageSetting';
import usePlatform from '@/components/Record/hooks/usePlatform';
import { useTranslation } from 'react-i18next';
import {
  approvalDialogActionsSx,
  approvalDialogPaperSx,
  getApprovalDialogActionButtonSx,
} from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/approvalDialogStyles';

type Props = SubContentProps & {
  open: boolean;
  onClose: () => void;
};

const WorkingHoursChangeModal = ({
  open,
  onClose,
  myInfo,
  openSubMenu,
}: Props) => {
  const { isMobilePath } = usePlatform();
  const { t } = useTranslation();

  const {
    formProps,
    currentWorkingHours,
    newWorkingHoursOptions,
    startYearMonthOptions,
    selectedNewWorkingHours,
    selectedStartYearMonth,
    isSubmitLoading,
    isSubmitDisabled,
  } = useWorkingHoursChangeProps({
    myInfo,
    menuOnClose: onClose,
    openSubMenu,
  });

  const actionButtonSx = getApprovalDialogActionButtonSx(isMobilePath);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullScreen={isMobilePath}
      PaperProps={!isMobilePath ? { sx: approvalDialogPaperSx } : undefined}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          padding: '12px 20px',
          fontSize: '16px',
          fontWeight: 500,
          backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
          borderBottom: '1px solid var(--dk-line, #E7E9EC)',
          lineHeight: '24px',
        }}
      >
        {t('MYPAGE.근무 시간 변경 신청')}
        <Button
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: '12px',
            top: '8px',
            padding: '4px',
            minWidth: 'auto',
          }}
        >
          <CloseIcon width="24px" height="24px" />
        </Button>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: 0,
        }}
      >
        <WorkingHoursChange
          formProps={formProps}
          currentWorkingHours={currentWorkingHours}
          newWorkingHoursOptions={newWorkingHoursOptions}
          startYearMonthOptions={startYearMonthOptions}
          selectedNewWorkingHours={selectedNewWorkingHours}
          selectedStartYearMonth={selectedStartYearMonth}
        />
      </DialogContent>
      <DialogActions sx={approvalDialogActionsSx}>
        <Button
          variant={'outlined'}
          size={'medium'}
          onClick={onClose}
          sx={actionButtonSx}
        >
          {t('MYPAGE.닫기')}
        </Button>
        <Button
          variant={'contained'}
          size={'medium'}
          type={'submit'}
          form={formProps.id}
          disabled={isSubmitDisabled || isSubmitLoading}
          sx={actionButtonSx}
        >
          {t('MYPAGE.신청 완료')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkingHoursChangeModal;
